import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { getToken } from "utils/api";

function RotaProtegida({ children }) {
  if (!getToken()) return <Navigate to="/auth/sign-in" replace />;
  return children;
}

const App = () => {
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route
        path="admin/*"
        element={
          <RotaProtegida>
            <AdminLayout />
          </RotaProtegida>
        }
      />
      <Route path="/" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default App;
